import { IAgentFlags } from "store/entities/agents";

export enum ReportType {
  Last7days = "last-7-days",
  NewTickets = "new-tickets",
  NewTicketsHeatmap = "new-tickets-heatmap",
  TicketRatings = "ticket-satisfaction",
  TicketFirstResponseTime = "first-response-time",
  SolvedAndClosed = "solved-and-closed",
  HandlingTimeByStatus = "handling-time-by-status",
  TicketResolutionTime = "ticket-resolution-time",
  ScheduledReports = "scheduled-reports",
  AuditLog = "audit-log",
}

export const REPORT_TYPE_KEYS = {
  [ReportType.Last7days]: "last7DaysVisitedDate",
  [ReportType.NewTickets]: "newTicketsVisitedDate",
  [ReportType.NewTicketsHeatmap]: "newTicketsHeatmapVisitedDate",
  [ReportType.TicketRatings]: "ticketSatisfactionVisitedDate",
  [ReportType.TicketFirstResponseTime]: "firstResponseTimeVisitedDate",
  [ReportType.SolvedAndClosed]: "solvedAndClosedVisitedDate",
  [ReportType.HandlingTimeByStatus]: "handlingTimeByStatusVisitedDate",
  [ReportType.TicketResolutionTime]: "ticketResolutionTimeVisitedDate",
  [ReportType.ScheduledReports]: "scheduledReportsVisitedDate",
  [ReportType.AuditLog]: "auditLogVisitedDate",
} satisfies Record<ReportType, keyof IAgentFlags>;

export const REPORTS_NEW_FEATURE_CAMPAIGNS: { [key in ReportType]?: [string, string, string][] } = {};

export enum ReportExportType {
  Normal = "raw",
  Agents = "agents",
}
